export const APP_NAME = 'NAICS Platform';
export const APP_DESCRIPTION = 'A powerful API to search for NAICS codes.';
